module.exports = {"id":"221838","name":"Miloš Jojić","rating":"75","photo":"./data/images/photos/3/221838.png","club":{"name":"1. FC Cologne","logo":"./data/images/clubs/1.FCCologne.png"},"positions":["MC","MD","MDC"],"photoFolderIndex":3}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/MilosJojic0.json
// module id = 3039
// module chunks = 0